import React from 'react';

const MenuMiTandC = () => {
  
  return (
      <>
      <h2>Privacy Policy</h2>
                <h3>
                    1. Privacy and Your Personal Data
                </h3>
                <p>
                    1.1 Agenbite Limited (trading as Milano) is committed to protecting the
                    privacy of our users and customers. This privacy policy ("Privacy Policy")
                    is intended to inform you on how we gather, define, and utilise your
                    Information (as defined below).
                </p>
                <p>
                    1.2 It applies to Information collected by us, or provided by you, whether
                    in one of our restaurants, over our Website (including the mobile optimised
                    version of the website accessible from your portable hand-held device) or
                    in any other way (such as over the telephone). It is also intended to
                    assist you in making informed decisions when using our Website and our
                    products and services. Please take a minute to read and understand the
                    policy.
                </p>
                <p>
                    1.3 All your personal Information shall be held and used in accordance with
                    the EU General Data Protection Regulation 2016/679 ("GDPR") and national
                    laws implementing GDPR and any legislation that replaces it in whole or in
                    part and any other legislation relating to the protection of personal data.
                    If you want to know what information we collect and hold about you, or to
                    exercise any of your rights as set out in section 9 below, please write to
                    us at the below address or via e-mail at feedback@milano.ie:
                </p>
                <p>
                    Agenbite Limited
                </p>
                <p>
                    38 Main Street
                </p>
                <p>
                    Swords
                </p>
                <p>
                    Dublin
                </p>
                <p>
                    County Dublin
                </p>
                <p>
                    Republic of Ireland
                </p>
                <p>
                    1.4 Agenbite Limited is the controller of your Information for the purposes
                    of the GDPR and is a company registered under number 0218338 and whose VAT
                    number is IE8218338W.
                </p>
                <h3>
                    2. What Information Do We Collect on our Website?
                </h3>
                <p>
                    2.1 When you visit our Website (including the mobile optimised version of
                    the website accessible from your portable hand-held device) you may provide
                    us with personal information such as name, postcode, email address, mobile
                    phone number, date of birth (month and year only) and information about
                    other members of your family who might be interested in our services
                    ("Information"). You may provide us with Information in a number of ways:
                </p>
                <p>
                    a) by supplying us with the Information as listed above, on an individual
                    basis by registering as a registered user or subscribing to receive updates
                    or offers from us. To become a registered user you must provide us with
                    your name, postcode, date of birth (month and year only), and email
                    address, but you may also provide us with additional information if you
                    choose to do so.
                </p>
                <p>
                    b) by corresponding with us by email, in which case we may retain the
                    content of your email messages together with your email address and our
                    responses;
                </p>
                <p>
                    c) by booking a table, downloading our offers, purchasing a gift card, or
                    applying for a job with us;
                </p>
                <p>
                    d) through any preferences and areas of interest as advised by you on
                    subscribing to our online services; and
                </p>
                <p>
                    e) by Information provided when you use our mobile optimised website from
                    your portable hand-held device including details of your physical location,
                    where you have agreed to it being used.
                </p>
                <p>
                    2.2 From time-to-time we may give you the option to provide us with
                    Information about other people in your life, for example as a registered
                    user, you have the option to tell us whether you have any children and if
                    so their gender and the month and year of their birth. We use this
                    Information to tell you about offers that may be relevant to your friends
                    or family members in accordance with their age.
                </p>
                <p>
                    2.3 We may collect Information about your computer, including where
                    available your IP address, operating system, browser type and the
                    geographical location of your computer, for system administration purposes.
                    We may also report aggregate information to our advertisers. This is
                    statistical data about browsing actions and patterns and does not identify
                    you as an individual.
                </p>
                <h3>
                    3. How we use your Information
                </h3>
                <p>
                    3.1 We will hold, use and disclose your Information for our legitimate
                    business purposes including:
                </p>
                <p>
                    a) to keep you up to date about important changes to our business;
                </p>
                <p>
                    b) to direct-market products and services, advise you of news and industry
                    updates, events, promotions and competitions and other information. Before
                    we do so, you will be given an option to opt-out of such communications and
                    an option to unsubscribe will also be provided with each communication;
                </p>
                <p>
                    c) to apply profiling technology which analyses our customers’ engagement
                    with our direct marketing communications, activity and interests so that we
                    can send you content that is relevant to you;
                </p>
                <p>
                    d) to answer your queries;
                </p>
                <p>
                    e) to provide further services to you by sharing your Information with
                    other companies within our group of companies, as well as trusted third
                    parties. Further details about this are set out in the section 8 below on
                    Sharing your Personal Information;
                </p>
                <p>
                    f) to release Information to regulatory or law enforcement agencies, if we
                    are required or permitted to do so.
                </p>
                <p>
                    3.2 We may process certain sensitive personal data (known as special
                    category data in GDPR) where you include it in information you send to us
                    e.g. if you include information about your health in booking requests. We
                    have processes in place to limit our use and disclosure of such sensitive
                    data other than where permitted by law.
                </p>
                <h3>
                    4. What Information do we collect in our restaurants or elsewhere?
                </h3>
                <p>
                    4.1 When you are in one of our restaurants, we may collect the following
                    Information when you use the Milano Wi-Fi service:
                </p>
                <p>
                    a) your name and contact details (date of birth), email address, postcode
                    and mobile telephone number)
                </p>
                <p>
                    b) your physical location, whilst you are in the restaurant only
                </p>
                <h3>
                    5. The legal basis for processing your Information
                </h3>
                <p>
                    5.1 Under GDPR, the main grounds that we rely upon in order to process your
                    Information are the following:
                </p>
                <p>
                    a) <strong>Necessary for compliance with a legal obligation</strong> – we
                    are subject to certain legal requirements which may require us to process
                    your Information. We may also be obliged by law to disclose your
                    Information to a regulatory body or law enforcement agency;
                </p>
                <p>
                    b) <strong>Necessary for the purposes of legitimate interests</strong> -
                    either we, or a third party, will need to process your Information for the
                    purposes of our (or a third party's) legitimate interests, provided we have
                    established that those interests are not overridden by your rights and
                    freedoms, including your right to have your Information protected. Our
                    legitimate interests include responding to requests and enquiries from you
                    or a third party, fulfilling gift card sales, optimising our website and
                    customer experience, informing you about our products and services and
                    ensuring that our operations are conducted in an appropriate and efficient
                    manner;
                </p>
                <p>
                    c) <strong>Consent</strong> – in some circumstances, we may ask for your
                    consent to process your Information in a particular way.
                </p>
                <h3>
                    6. How we share your Information
                </h3>
                <p>
                    6.1 In certain circumstances we will share your Information with other
                    parties. Details of those parties are set out below along with the reasons
                    for sharing it.
                </p>
                <p>
                    a) <strong>Other parties within our group of companies:</strong> Your
                    information may be shared with our UK affiliates including our parent
                    company, as certain processing functions within Milano and PizzaExpress
                    are centralised. Your information will not be shared with any of our
                    international affiliates.
                </p>
                <p>
                    b) <strong>Trusted third parties:</strong> In order to provide certain
                    services, we will share your information with third party service providers
                    such as IT infrastructure companies and email logistics providers. We will
                    not share your data with any third party where it is not necessary to do so
                    to provide a service to you.
                </p>
                <p>
                    c) <strong>Regulatory and law enforcement agencies</strong>. As noted
                    above, if we receive a request from a regulatory body or law enforcement
                    agency, and if permitted under GDPR and other laws, we may disclose certain
                    personal information to such bodies or agencies.
                </p>
                <p>
                    d) <strong>New business owners</strong>. If we or our business merges with
                    or is acquired by another business or company, we will share your personal
                    information with the new owners of the business or company and their
                    advisors. If this happens, you will be sent notice of such event.
                </p>
                <h3>
                    7. How long we hold your Information
                </h3>
                <p>
                    We will only retain your Information for as long as is necessary for the
                    purpose or purposes for which we have collected it. The criteria that we
                    use to determine retention periods will be determined by the nature of the
                    data and the purposes for which it is kept. For example, if we receive your
                    Information through a competition entry, we will retain your data for as
                    long as is necessary to administer the competition. If we receive your
                    Information when you apply for a job, we will retain your data for as long
                    as is necessary to process your application, and maintain application
                    statistics. We will not directly market to you for longer than three (3)
                    years, unless you consent to receive direct marketing by opting in again
                    before the expiry of that three (3) year period. In certain circumstances,
                    once we have deleted or anonymised your data, we may need to retain parts
                    of it (for example, your email address), in order to comply with our
                    obligations under GDPR or other legislation, or for fraud detection
                    purposes.
                </p>
                <h3>
                    8. Your rights relating to your Information
                </h3>
                <p>
                    8.1 You have certain rights in relation to personal information we hold
                    about you. Details of these rights and how to exercise them are set out
                    below. We will require evidence of your identity before we are able to act
                    on your request.
                </p>
                <p>
                    a) <strong>Right of Access</strong>. You have the right at any time to ask
                    us for a copy of the Information about you that we hold, and to confirm the
                    nature of the Information and how it is used. Where we have good reason,
                    and if the GDPR permits, we can refuse your request for a copy of your
                    Information, or certain elements of the request. If we refuse your request
                    or any element of it, we will provide you with our reasons for doing so.
                </p>
                <p>
                    b) <strong>Right of Correction or Completion</strong>. If Information we
                    hold about you is not accurate, or is out of date or incomplete, and
                    requires amendment or correction you have a right to have the data
                    rectified, updated or completed. You can let us know by contacting us at
                    the address or email address set out above.
                </p>
                <p>
                    c) <strong>Right of Erasure</strong>. In certain circumstances, you have
                    the right to request that Information we hold about you is erased e.g. if
                    the Information is no longer necessary for the purposes for which it was
                    collected or processed or our processing of the Information is based on
                    your consent and there are no other legal grounds on which we may process
                    the Information.
                </p>
                <p>
                    d) <strong>Right to Object to or Restrict Processing</strong>. In certain
                    circumstances, you have the right to object to our processing of your
                    Information by contacting us at the address or email address set out above.
                    For example, if we are processing your Information on the basis of our
                    legitimate interests and there are no compelling legitimate grounds for our
                    processing which override your rights and interests. You also have the
                    right to object to use of your Information for direct marketing purposes.
                </p>
                <p>
                    You may also have the right to restrict our use of your Information, such
                    as in circumstances where you have challenged the accuracy of the
                    Information and during the period where we are verifying its accuracy.
                </p>
                <p>
                    e) <strong>Right of Data Portability</strong>. In certain instances, you
                    have a right to receive any Information that we hold about you in a
                    structured, commonly used and machine-readable format. You can ask us to
                    transmit that Information to you or directly to a third party organisation.
                </p>
                <p>
                    This right exists in respect of Information that:
                </p>
                <p>
                    • you have provided to us previously; and
                </p>
                <p>
                    • is processed by us using automated means.
                </p>
                <p>
                    While we are happy for such requests to be made, we are not able to
                    guarantee technical compatibility with a third party organisation's
                    systems. We are also unable to comply with requests that relate to
                    Information of others without their consent.
                </p>
                <p>
                    8.2 You can exercise any of the above rights by contacting us at the
                    address or e-mail address set out above. You can exercise your rights free
                    of charge.
                </p>
                <p>
                    8.3 Most of the above rights are subject to limitations and exceptions. We
                    will provide reasons if we are unable to comply with any request for the
                    exercise of your rights.
                </p>
                <h3>
                    9. Consent
                </h3>
                <p>
                    To the extent that we are processing your Information based on your
                    consent, you have the right to withdraw your consent at any time. You can
                    do this by unsubscribing via the link provided in any direct marketing
                    communication, or contacting us at the address or email address set out
                    above.
                </p>
                <h3>
                    10. Cookies
                </h3>
                <p>
                    10.1 Similar to other commercial websites, our Website uses a technology
                    called "cookies" and web server logs to collect information about how our
                    Website is used. A cookie is a very small text document, which often
                    includes an anonymous unique identifier. When you visit a website, that
                    site's computer asks your computer for permission to store this file in a
                    part of your hard drive specifically designated for cookies
                </p>
                <p>
                    10.2 Information gathered through cookies and web server logs may include
                    the date and time of visits, the pages viewed, time spent at our Website,
                    and the websites visited just before and just after our Website.
                </p>
                <p>
                    10.3 Cookies, in conjunction with our web server's log files, allow us to
                    calculate the aggregate number of people visiting our Website and which
                    parts of the website are most popular. This helps us gather feedback so
                    that we can improve our Website and better serve our customers. Cookies do
                    not allow us to gather any personal Information about you and we do not
                    generally store any personal Information that you provided to us in your
                    cookies.
                </p>
                <p>
                    10.4 We use ‘session’ cookies which enable you to carry information across
                    pages of the Website and avoid having to re-enter information. Session
                    cookies enable us to compile statistics that help us to understand how the
                    Website is being used and to improve its structure.
                </p>
                <p>
                    10.5 We also use ‘persistent’ cookies which remain in the cookies file of
                    your browser for longer and help us to recognise you as a unique visitor to
                    the Website, tailoring the content of certain areas of the Website to offer
                    you content that match your preferred interests.
                </p>
                <h3>
                    11. Website Accessibility
                </h3>
                <p>
                    11.1 Milano recognises the importance of providing a website that is
                    accessible to everyone and is easy to use. This section outlines our
                    ongoing commitment to making our online services accessible and explains
                    some of the accessibility features of this Website.
                </p>
                <p>
                    11.2 Website accessibility means that people with disabilities can use the
                    Website. More specifically, Website accessibility means that people with
                    disabilities can perceive, understand, navigate, and interact with the
                    Website, and that they can contribute to the Website. Website accessibility
                    also benefits others, including older people with changing abilities due to
                    aging. (Quote from https://www.w3.org/WAI/intro/accessibility.php)
                </p>
                <p>
                    11.3 This Website contains the following features which should help users
                    make the website more accessible:
                </p>
                <p>
                    a) providing a sitemap;
                </p>
                <p>
                    b) every content and decorative image has the ability to have alternative
                    text added so if images are disabled or not appearing the user can see read
                    what the image is displaying;
                </p>
                <p>
                    c) tabbing through the Website is organised in a logical top down left to
                    right order;
                </p>
                <p>
                    d) clearly defined visible hover and focus (tab) state for each link;
                </p>
                <p>
                    e) the ability to jump to the main content on the page by bypassing the top
                    menu when you use the keyboard;
                </p>
                <p>
                    f) HTML for lists, tables and quotes being coded correctly;
                </p>
                <p>
                    g) the ability to navigate around the site and access all functionality by
                    only using the keyboard;
                </p>
                <p>
                    h) all fields and labels within forms including error messages, are clearly
                    labelled and have the correct notations;
                </p>
                <p>
                    i) the visual contrast combination of text and background colours meet the
                    correct ratio so all text is easily read; and
                </p>
                <p>
                    j) the Website is readable when large size text is used in Internet
                    Explorer
                </p>
                <p>
                    11.4 At Milano we are committed to making our Website accessible to as many
                    abled and less abled people as possible. We will continue to review, test
                    and modify our Website for usability and accessibility issues using a
                    combination of both manual and automated testing tools. These tools and
                    techniques help us to aim towards meeting (where possible) the W3C
                    guidelines as part of our ongoing commitment towards an accessible Website.
                </p>
                <h3>
                    12. Changes to our Privacy Policy
                </h3>
                <p>
                    This privacy policy can be changed by us at any time. If we change our
                    privacy policy in the future, we will advise you of material changes or
                    updates to our privacy policy by e-mail, where we are holding your e-mail
                    address.
                </p>
                <h3>
                    13. Complaints
                </h3>
                <p>
                    If you are unhappy about our use of your Information, you can contact us at
                    the address or e-mail address above. You are also entitled to lodge a
                    complaint with the Irish Data Protection Commissioner’s Office using any of
                    the below contact methods:
                </p>
                <p>
                    Telephone: +353 (0761) 104 800
                </p>
                <p>
                    Email: info@dataprotection.ie
                </p>
                <p>
                    Post: Office of the Data Protection Commissioner
                </p>
                <p>
                    Canal House
                </p>
                <p>
                    Station Road
                </p>
                <p>
                    Portarlington
                </p>
                <p>
                    Co.Laois
                </p>
                <p>
                    R32 AP23
                </p>
      </>
    );
  }

export default MenuMiTandC;